<template>
    <div class="box">
        <ul v-on:change="selectVehicle">
            <li v-for="vehicle in vehicleTypes" :key="vehicle.id">
                <input type="radio" :value="vehicle.name" name="type-of-vehicle" :id="vehicle.id" required :checked="vehicle.id == vehicleId">
                <label :for="vehicle.id">
                    <img :src="require(`@/assets/icons/${vehicle.name.toLowerCase().replace(/\s/g, '-')}.svg`)" alt="" class="icon" />
                    <span class="label" v-translate>{{ vehicle.name }}</span>
                    <p
                            class="meta"
                            v-if="vehicle.id === '2' || vehicle.id === '4'"
                    >Longueur max.: <span>8,5m</span><img src="../assets/ui/enlarge.svg" class="svg" alt=""></p>
                </label>
            </li>
        </ul>
    </div>
</template>

<script>
    const axios = require('axios');
    const VueScrollTo = require('vue-scrollto');
    var cancelScroll;

    export default {
        name: 'VehicleSelection',
        data: function() {
            return({
                vehicle: this.$store.state.vehicleType,
                vehicleId: this.$store.state.vehicleTypeId,
                needsToScroll: true,
                vehicleTypes: [],
            })
        },
        mounted() {
            axios
                .get(`${this.$store.state.domain}/api/fr/vehicle-types`)
                .then(response => {
                    this.vehicleTypes = response.data;
                })
                .catch(error => {
                    this.$store.commit('addErrorMessage', error.response.data.extraData.message);
                    this.$store.commit('lockApp');
                })
        },
        methods: {
            selectVehicle(ev) {
                const v = this;
                this.$store.commit('changeData', {
                   type: 'vehicleType',
                   value: ev.target.value,
                });
                this.$store.commit('changeData', {
                    type: 'vehicleTypeId',
                    value: ev.target.id,
                });

                this.$store.dispatch('resetCalendar')

                this.$store.commit('showSection', 'dateSelection');
                //scroll to section after validated card
                if (this.needsToScroll) {
                    setTimeout(function () {
                        cancelScroll = VueScrollTo.scrollTo('#date', 1000, { onCancel: function() { cancelScroll(); } });
                        v.needsToScroll = false;
                    }, 500);
                }
            }
        }
    }
</script>

<style scoped>
    .box {
        position: relative;
        padding-top: 50px;
        padding-bottom: 100px;
    }

    .box::before {
        content: "";
        background-color: var(--green--light);
        position: absolute;
        top: 0;
        right: -50vw;
        bottom: 0;
        left: -50vw;
        z-index: -1;
    }

    h2 {
        color: var(--green--dark);
    }

    h2 span {
        font-family: gill-sans-nova, sans-serif;
        font-weight: 700;
        font-size: 24px;
    }

    @media only screen and (max-width: 500px) {
        h2 span {
            display: block;
            margin-bottom: 10px;
        }
    }

    ul {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(390px, 1fr));
        column-gap: 30px;
        row-gap: 0;
    }

    @media only screen and (max-width: 500px) {
        ul {
            grid-template-columns: 1fr;
        }
    }

    li {
        color: var(--green--dark);
        padding: var(--xmedium) 4px 4px var(--xmedium);
        position: relative;
    }

    @media only screen and (max-width: 500px) {
        li {
            padding: var(--medium) 4px 4px var(--xmedium);
        }
    }

    label:hover {
        cursor: pointer;
    }

    label {
        border-bottom-right-radius: 30px;
        background-color: white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-height: 140px;
        position: relative;
        transition: color 0.2s ease;
    }

    @media only screen and (max-width: 500px) {
        label {
            min-height: 100px;
        }
    }

    label::after {
        content: "";
        border-radius: 50%;
        border: 2px solid var(--green);
        height: 25px;
        position: absolute;
        top: 25px;
        right: 25px;
        width: 25px;
    }

    .label {
        font-size: 26px;
        font-weight: 700;
        padding: 0 60px 0 100px;
    }

    @media only screen and (max-width: 500px) {
        label {
          padding: 15px 0;
        }

        .label {
            padding: 0 60px;
            font-size: 21px;
        }
    }

    input:checked + label {
        color: white;
        background-color: var(--green);
    }

    input:checked + label::after {
        border: 2px solid white;
        background-color: white;
    }

    input:focus + label {
        box-shadow: 0px 0px 5px 2px var(--green--dark);
    }

    input:checked + label::before {
        content: "";
        border-radius: 50%;
        border: 5px solid var(--green);
        height: 21px;
        position: absolute;
        top: 27px;
        right: 27px;
        width: 21px;
        z-index: 2;
    }

    .icon {
        border-radius: 50%;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.17);
        height: 110px;
        position: absolute;
        top: -30px;
        left: -30px;
        width: 110px;
    }

    @media only screen and (max-width: 500px) {
        .icon {
            height: 60px;
            width: 60px;
        }
    }

    .meta {
        margin: 5px 0 0;
        padding: 0 60px 0 100px;
    }

    @media only screen and (max-width: 500px) {
      .meta {
        padding: 0 60px 0 60px;
      }
    }


    .meta span {
        font-weight: bold;
    }

    .meta .svg {
        margin-left: 5px;
    }
</style>
